import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { useMemo } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const SearchService = ({ formik,
    groupList, setGroupList,
    businessList, orgAddress,
    setOrgAddress, serviceList,
    setServiceList, filterBTN, setFilterBTN }) => {

    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const { readDataByFilter: readDataService } = useEntityCrud('Service/GetAllServices')

    const [storageItemBusiness, setStorageItemBusiness] = useState([])
    const [storageItemGroup, setStorageItemGroup] = useState([])
    const [storageItemService, setStorageItemService] = useState([])


    const businessAll = useMemo(() => businessList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const groupAll = useMemo(() => groupList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const serviceAll = useMemo(() => serviceList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));


    useEffect(() => {
        const postedData = {
            buisnessId: orgAddress.buisnessId.value || parseInt(localStorage.getItem("buinessID")),
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result)
            console.log(groupList);
        });
    }, [businessList, orgAddress.buisnessId])


    useEffect(() => {
        const postedData = {
            groupId: orgAddress.groupId.value || parseInt(localStorage.getItem("groupID")),
        };
        readDataService(postedData).then(res => {
            setServiceList(res.data.result)
        });
    }, [orgAddress.groupId.value])

    useEffect(() => {

        const searchDetailsBusinessId = parseInt(localStorage.getItem("buinessID"));
        setStorageItemBusiness({
            value: businessAll?.find(it => it.value === searchDetailsBusinessId),
            label: businessAll?.find(it => it.value === searchDetailsBusinessId)?.label
        })

        const searchDetailsGroupId = parseInt(localStorage.getItem("groupID"));
        setStorageItemGroup({
            value: groupAll?.find(it => it.value === searchDetailsGroupId),
            label: groupAll?.find(it => it.value === searchDetailsGroupId)?.label
        })

        const searchDetailsServiceId = parseInt(localStorage.getItem("serviceID"));
        setStorageItemService({
            value: serviceAll?.find(it => it.value === searchDetailsServiceId),
            label: serviceAll?.find(it => it.value === searchDetailsServiceId)?.label
        })

    }, [businessList])

    const handleChangeBusiness = (value) => {
         
        localStorage.removeItem("buinessID");
        localStorage.removeItem("groupID");
        localStorage.removeItem("serviceID");

        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: "" }))
        setOrgAddress(prevState => ({ ...prevState, buisnessId: value }))

        setStorageItemGroup({
            value: "",
            label: ""
        })

        setStorageItemService({
            value: "",
            label: ""
        })
    }


    const handleChangeGroup = (value) => {

        localStorage.removeItem("groupID");
        localStorage.removeItem("serviceID");

        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: value }))

        setStorageItemService({
            value: "",
            label: ""
        })
    }

    const handleChangeService = (value) => {
        setOrgAddress(prevState => ({ ...prevState, serviceId: value }))
    }





    /*     const filterData = () => {
             
            orgAddress.buisnessId = "";
            orgAddress.groupId = "";
            orgAddress.serviceId = "";
            localStorage.removeItem("buinessID");
            localStorage.removeItem("groupID");
            localStorage.removeItem("serviceID");
            setFilterBTN(false)
        }
    
     */


    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row mb-4">

                <div className="col-md-3">
                    <label>
                        کسب و کار
                    </label>
                    <ReactSelect label="   کسب و کار"
                        options={businessAll.filter(item => item.isActive === true)}
                        value={orgAddress.buisnessId || storageItemBusiness}
                        onChange={handleChangeBusiness}
                        placeholder="انتخاب کنید"
                        name="buisnessId"
                    />
                </div>
                <div className="col-md-3">
                    <label>
                        گروه
                    </label>
                    <ReactSelect label="گروه"
                        options={groupAll.filter(item => item.isActive === true)}
                        placeholder="انتخاب کنید"
                        name="groupId"
                        value={orgAddress.groupId || storageItemGroup}
                        onChange={handleChangeGroup}
                    />
                </div>
                <div className="col-md-3">
                    <label>
                        سرویس
                    </label>
                    <ReactSelect label="سرویس"
                        options={serviceAll.filter(item => item.isActive === 1)}
                        placeholder="انتخاب کنید"
                        name="serviceId"
                        value={orgAddress.serviceId || storageItemService}
                        onChange={handleChangeService}
                    />
                </div>

                <div className='col-md-3 mt-4 pt-3'>
                    <button className="btn btn-success">نمایش اطلاعات</button>
                    {/*                     {filterBTN && <button className="btn btn-danger mx-2" onClick={() => filterData()}>حذف اطلاعات</button>}
 */}
                </div>

            </div>
        </form >
    );
}

export default SearchService;